<template>
    <div class="row w-100 mx-auto px-0">
        <div class="col-md-3">
            <div class="card w-full">
                <div :class="`card-body rounded-lg bg-danger`">
                    <div class="media">
                        <div class="media-body overflow-hidden">
                            <p class="text-truncate text-white font-size-14 mb-2">تعداد شروع نمایش</p>
                            <h4 class="text-white mb-0">{{ $helper.formatPrice(record.startShow) }}</h4>
                        </div>
                        <div class="text-white">
                            <i class="font-size-24 ri-eye-line"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card w-full">
                <div :class="`card-body rounded-lg bg-warning`">
                    <div class="media">
                        <div class="media-body overflow-hidden">
                            <p class="text-truncate text-white font-size-14 mb-2">تعداد اتمام نمایش</p>
                            <h4 class="text-white mb-0">{{ $helper.formatPrice(record.endShow) }}</h4>
                        </div>
                        <div class="text-white">
                            <i class="font-size-24 ri-eye-off-line"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card w-full">
                <div :class="`card-body rounded-lg bg-primary`">
                    <div class="media">
                        <div class="media-body overflow-hidden">
                            <p class="text-white font-size-14 mb-2">تعداد کلیک</p>
                            <h4 class="text-white mb-0">
                                {{ $helper.formatPrice(record.click) }} </h4>
                        </div>
                        <div class="text-white">
                            <i class="font-size-24 ri-mouse-line"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card w-full">
                <div :class="`card-body rounded-lg bg-success`">
                    <div class="media">
                        <div class="media-body overflow-hidden">
                            <p class="text-truncate text-white font-size-14 mb-2">تعداد نصب</p>
                            <h4 class="text-white mb-0">{{ $helper.formatPrice(record.install) }}</h4>
                        </div>
                        <div class="text-white">
                            <i class="font-size-24 ri-install-line"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div class="col-md-4">-->
<!--            <div class="card w-full">-->
<!--                <div :class="`card-body rounded-lg bg-primary`">-->
<!--                    <div class="media">-->
<!--                        <div class="media-body overflow-hidden">-->
<!--                            <p class="text-truncate text-white font-size-14 mb-2">درصد جذابیت ویدئو</p>-->
<!--                            <h4 class="text-white mb-0">{{ ((this.record.endShow * 100) / this.record.startShow).toFixed(2) }}%</h4>-->
<!--                        </div>-->
<!--                        <div class="text-white">-->
<!--                            <i class="font-size-24 ri-video-line"></i>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-md-4">-->
<!--            <div class="card w-full">-->
<!--                <div :class="`card-body rounded-lg bg-warning`">-->
<!--                    <div class="media">-->
<!--                        <div class="media-body overflow-hidden">-->
<!--                            <p class="text-truncate text-white font-size-14 mb-2">درصد جذابیت بنر</p>-->
<!--                            <h4 class="text-white mb-0">{{ ((this.record.click * 100) / this.record.endShow).toFixed(2) }}%</h4>-->
<!--                        </div>-->
<!--                        <div class="text-white">-->
<!--                            <i class="font-size-24 ri-image-line"></i>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-md-4">-->
<!--            <div class="card w-full">-->
<!--                <div :class="`card-body rounded-lg bg-success`">-->
<!--                    <div class="media">-->
<!--                        <div class="media-body overflow-hidden">-->
<!--                            <p class="text-truncate text-white font-size-14 mb-2">درصد جذابیت برنامه</p>-->
<!--                            <h4 class="text-white mb-0">{{ ((this.record.install * 100) / this.record.click).toFixed(2) }}%</h4>-->
<!--                        </div>-->
<!--                        <div class="text-white">-->
<!--                            <i class="font-size-24 ri-apps-line"></i>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    name: "total-data",
    props: {
        record: {
            type: Object,
            required: true
        }
    },
    computed: {
        grow() {
            let grow = 0
            switch (this.record.tablighKindId) {
                case 1:
                    grow = (this.record.endShow * 100) / this.record.startShow
                    break;
                case 2:
                    grow = (this.record.click * 100) / this.record.endShow
                    break;
                case 3:
                    grow = (this.record.install * 100) / this.record.endShow
                    break;
            }
            return grow
        }
    }
}
</script>
